


















import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcCounterpart extends Vue {
  @Prop({ default: false}) public needsCustomer: boolean;
  @Prop({ default: false}) public needsSupplier: boolean;
  @Prop({ default: false}) public needsReceiver: boolean;
  @Prop({ default: false}) public needsWarehouse: boolean;
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop({ default: null }) public customer: Common.Counterpart;
  @Prop() public tooltip: string;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
  }
    destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }

  public queryProvider(search:string, perPage:number, currentPage:number){
    var query = new Common.CounterpartMasterQuery();
    query.needsCustomer = this.needsCustomer;
    query.needsSupplier = this.needsSupplier;
    query.needsReceiver = this.needsReceiver;
    query.needsWarehouse = this.needsWarehouse;
    query.customerId = this.customer ? this.customer.id : null;
    
    query.search = search ? search : '';
    query.perPage = perPage;
    query.currentPage = currentPage;

    return query;
  }

  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');
  }

  @Watch('customer')
  onCustomerChanged(newCustomer:Common.Counterpart, oldCustomer:Common.Counterpart) {
    if(this.needsReceiver == false) return;
    if(this.isEdit == false) return;
    var oldCustomerId:number = oldCustomer == null ? 0 : oldCustomer.id;
    if(newCustomer == null || (newCustomer.id != oldCustomerId)){
      this.$emit('update:value', null);
    }
  }

  public onLinkClicked(){
    this.onFuncClicked();
    // let routeData = this.$router.resolve(String.format('/master/Counterpart?auditNo={0}', (this.value as Common.Counterpart).code)) ;
    // window.open(routeData.href, '_blank');         
  }    

  public showEditor = false;
  public onFuncClicked(){
    this.showEditor = true;
  }
  public get counterpartTypeDisabled(){
    return (this.needsCustomer ? 0 : Common.CounterpartTypes.Customer) | 
              (this.needsSupplier ? 0 : Common.CounterpartTypes.Supplier) | 
              (this.needsReceiver ? 0 : Common.CounterpartTypes.Receiver) | 
              (this.needsWarehouse ? 0 : Common.CounterpartTypes.Warehouse);
  }
  public onEditorClosing(arg : any){
    var obj = ((this.$refs.editor as Components.Counterpart).$refs.mainList as Components.ListView).selected;
    if (obj.id == 0) return; //未保存の場合はキャンセル可

    if ((obj as Common.MasterBase).state != Common.MasterBaseStatus.Posted) {
      arg.canceled = true;
      this.$api.modal.show('無効な操作','編集画面を閉じる前に確定してください。', true,null);      
      return;
    }
    //オブジェクトを更新する
    this.$emit('update:value', obj);    
    this.$emit('closed', obj);        
  }
}
  
